import PropTypes from 'prop-types'
import { useState, useEffect, Fragment } from 'react'
import MenuFiltros from '../MenuFiltros'
import ComponenteError from '../publicaciones/ComponenteError'
import Publicacion from '../publicaciones/Publicacion'
import * as favoritosService from '../servicios/favoritosService'
import BordePrincipal from '../ui/BordePrincipal'

const Favoritos = (props) => {
  const [favoritos, setFavoritos] = useState([])

  useEffect(() => {
    const fetchFavoritos = async () => {
      const userId = localStorage.idUsuario
      if (!userId) {
        return
      }

      const { data: favoritos } = await favoritosService.buscarPorUsuario(userId)
      setFavoritos(favoritos.filter((fav) => fav.idVendedor !== parseInt(userId)))
      toggleClases(0)
    }

    fetchFavoritos()
  }, [localStorage.idUsuario])

  const handleToggle = (event, favorito, idPublicacion) => {
    toggleClases(idPublicacion)
    props.onToggleClick(event, favorito, idPublicacion)
  }

  const toggleClases = (idPublicacion) => {
    setFavoritos((prevFavoritos) =>
      prevFavoritos.map((favorito) =>
        favorito.idPublicacion === idPublicacion
          ? { ...favorito, clase: 'row item fila clicked' }
          : { ...favorito, clase: 'row item fila' }
      )
    )
  }

  const updateFavoritos = async (idpub) => {
    const newFav = favoritos.filter((pub) => pub.idPublicacion !== idpub)
    setFavoritos(newFav)
  }

  const cantFavorito = favoritos.length - 1

  return (
    <>
      <MenuFiltros idComponente={0} />
      <BordePrincipal titulo="Mis Favoritos">
        {favoritos.map((publicacion) => (
          <Fragment key={publicacion.idPublicacion}>
            <Publicacion
              onToggleClick={handleToggle}
              publicacion={publicacion}
              compFavorito={true}
              onDelete={updateFavoritos}
            />
          </Fragment>
        ))}
        {cantFavorito === -1 && (
          <div className="row">
            <ComponenteError tipo="i" idAviso={5} />
          </div>
        )}
      </BordePrincipal>
    </>
  )
}

Favoritos.propTypes = {
  onToggleClick: PropTypes.func.isRequired
}

export default Favoritos
